import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import { Row, Col, ButtonGroup, Button, Form, FormGroup, FormText, Label, Input, FormFeedback, ListGroup, ListGroupItem } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import moment from 'moment';
import Autocomplete from 'react-autocomplete';

import { capitalizeFirstLetter } from '../../../../util/text';
import { sequence } from '../../../../util/promises';

import { getAvalaibleCountries, getCountryNameTranslation } from '../../../App/AppActions';
import { editAddressRequest, getAddresses } from '../../../Address/AddressActions';
import { subscribeNewsletterRequest, getLoggedUser, isUserSubscribedToNewsletter, USER_EMAIL_REGEX, USER_PASSWORD_REGEX } from '../../UserActions';
import { displayErrors } from '../../../Error/ErrorActions';

import AddressEditForm from '../../../Address/components/form/AddressEditForm';
import AddressView from '../../../Address/components/view/AddressView';
import User from '../../User';

import CmsPanel from '../../../Cms/components/content/CmsPanel';


class UserRegisterAndAddressForm extends User {
    constructor(props) {
        super(props);

        Object.assign(this.state, {
            shippingAddress: {},
            invoiceAddress: {},
            shippingAddressId: null,
            invoiceAddressId: null,
            hasDistinctInvoiceAddress: false,
            isSubscribingNewsletter: props.user ? isUserSubscribedToNewsletter(props.user, 'general') : false,
            isProcessing: false,
        });

        this.countries = getAvalaibleCountries();
    }

    isValid() {
        return (this.props.user || (
                this.state.firstName
                && this.state.lastName
                && this.state.email
                && USER_EMAIL_REGEX.test(this.state.email)
                && this.state.password && USER_PASSWORD_REGEX.test(this.state.password)
            ))
            && (this.state.shippingAddressId || this.isAddressValid(this.state.shippingAddress))
            && (!this.hasDistinctInvoiceAddress || this.state.invoiceAddressId || this.isAddressValid(this.state.invoiceAddress));
    }

    isAddressValid(address) {
        const generalCheck = address.street1
            && address.postalCode
            && address.city
            && address.country
            && address.phone;
        let countryCheck = true;
        const countryData = this.getCountryData(address.country);
        switch((countryData || {}).cca2) {
            case 'US':
            case 'CA':
                countryCheck = !!address.region;
                break;

            default:
                console.log(countryData);
        }
        return generalCheck && countryCheck;
    }

    getCountryData(countryName) {
        countryName = `${countryName || ''}`.toLowerCase().trim();
        let countryData = this.countries.find(country => country.cca2.toLowerCase().trim() === countryName);
        if(!countryData) {
            countryData = this.countries.find(country => (
                country.name.common.toLowerCase().trim() === countryName
                || Object.entries(country.translations).some(translation => ((translation[1] || {}).common || '').toLowerCase() === countryName)
            ));
            if(!countryData) {
                countryData = this.countries.find(country => Object.entries(country.translations).some(translation => (translation[1].common || '').toLowerCase().indexOf(countryName) !== -1));
            }
        }
        return countryData;
    }

    handleChangeAddress(event, type) {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [`${type}Address`]: {
                ...this.state[`${type}Address`],
                [name]: value,
            },
        });
    }

    handleSubmit = event => {
        event.preventDefault();

        if(this.isValid()) {
            this.setState({
                isProcessing: true,
            });

            const isNewUser = !this.props.user;

            const preferedCountryData = isNewUser && this.getCountryData((this.state.invoiceAddress.country || this.state.shippingAddress.country));
            const preferedCountryCode = preferedCountryData ? preferedCountryData.cca2 : '';


            (
                this.props.user
                ? (this.state.isSubscribingNewsletter !== isUserSubscribedToNewsletter(this.props.user, 'general')
                    ? this.props.dispatch(subscribeNewsletterRequest('general', this.state.isSubscribingNewsletter)).then(() => Promise.resolve(this.props.user))
                    : Promise.resolve(this.props.user)
                )
                : this.handleRegister({
                        email: this.state.email,
                        password: this.state.password,
                        firstName: this.state.firstName,
                        lastName: this.state.lastName,
                        preferences: { language: this.props.intl.locale, country: preferedCountryCode },
                        newsletterSubscriptions: [{ name: 'general', status: 'subscribed', dates: { subscribed: moment.utc().format() } }],
                    })
            ).then(user => {
                if(user) {
                    Promise.all(['shipping', 'invoice'].filter(type => type === 'shipping' || this.state.hasDistinctInvoiceAddress).map(type => {
                        if(this.state[`${type}AddressId`]) {
                            return Promise.resolve(this.props.addresses.find(address => address._id === this.state[`${type}AddressId`]));
                        }

                        const countryData = this.getCountryData(this.state[`${type}Address`].country);
                        return this.props.dispatch(editAddressRequest({
                            ...this.state[`${type}Address`],
                            label: this.state[`${type}Address`].nameAlt || '',
                            name: `${this.state[`${type}Address`].nameAlt ? `${this.state[`${type}Address`].nameAlt ? `${this.state[`${type}Address`].nameAlt} - ` : ''}` : ''}${user.firstName || ''} ${user.lastName || ''}`,
                            countryCode: countryData ? countryData.cca2 : '',
                            country: countryData ? countryData.name.common : this.state[`${type}Address`].country,
                            isUsedForInvoice: type === 'invoice' || !this.state.hasDistinctInvoiceAddress,
                        }));
                    })).then(([shippingAddress, invoiceAddress]) => {
                        isNewUser && displayErrors('success', this.props.intl.formatMessage({
                            id: 'userRegisterSuccess',
                            defaultMessage: 'Congratulations! Your account has been created!',
                        }, { user: user.email }));
                        this.props.closeForm && this.props.closeForm(user, shippingAddress, invoiceAddress);
                    }).catch(err => {
                        this.setState({
                            isProcessing: false,
                        });
                    });
                } else {
                    this.setState({
                        isProcessing: false,
                    });
                    displayErrors('error', this.props.intl.formatMessage({
                        id: 'userRegisterError',
                        defaultMessage: 'Unable to create your account! Please retry...',
                    }));
                }
            });
        } else {
            const errorFields = [];
            if(!this.state.email || !USER_EMAIL_REGEX.test(this.state.email)) {
                errorFields.push('email');
            }
            if(!this.state.firstName) {
                errorFields.push('firstName');
            }
            if(!this.state.lastName) {
                errorFields.push('lastName');
            }
            if(!this.state.password || !USER_PASSWORD_REGEX.test(this.state.password)) {
                errorFields.push('password');
            // } else if(this.state.password !== this.state.confirmPassword) {
            //     errorFields.push('confirmPassword');
            }

            ['shipping', 'invoice'].forEach(addressType => {
                const countryData = this.getCountryData(this.state[`${addressType}Address`].country);
                !this.state[`${addressType}AddressId`] && errorFields.push(`${addressType}AddressId`);
                ['street1', 'postalCode', 'city', 'region', 'country', 'phone'].forEach(addressField => {
                    if(!this.state[`${addressType}Address`][addressField]) {
                        if(addressField !== 'region' || ['US', 'CA'].includes((countryData || {}).cca2)) {
                            errorFields.push(`${addressType}Address${capitalizeFirstLetter(addressField)}`);
                        }
                    }
                });
            });
            // console.log(errorFields);
            this.setState({ errorFields });
            // displayErrors('error', this.props.intl.messages.alertFormRequiredFieldsError);
        }
    }

    renderAddressForm(type) {
        if(this.state[`display${capitalizeFirstLetter(type)}AddressForm`]) {
            return (
                <div>
                    <span className="d-block my-3 h5 text-primary"><FormattedMessage id={`address${capitalizeFirstLetter(type)}`} defaultMessage={`${capitalizeFirstLetter(type)} address`} /></span>
                    <AddressEditForm address={this.props.addresses.find(address => address._id === this.state[`${type}AddressId`])} closeForm={address => this.setState({ [`display${capitalizeFirstLetter(type)}AddressForm`]: false, [`${type}AddressId`]: (address && address._id) || this.state[`${type}AddressId`] })} />
                </div>
            );
        }
        if(this.props.addresses.length) {
            return (
                <Row className="mb-3">
                    <Col xs="12" md="12" className="text-left">
                        <span className="text-dark special-font">
                            <strong><FormattedMessage id={`cart${capitalizeFirstLetter(type)}AddressSelectionTitle`} defaultMessage={`Select your ${capitalizeFirstLetter(type)} address`} /></strong><br />
                        </span>
                    </Col>
                    <Col>
                        <FormGroup className="mb-2">
                            {false && (
                                <Input type="select" className={classnames(this.hasErrorField(`${type}AddressId`) && !this.state[`${type}AddressId`] && 'is-invalid form-control-danger')} name={`${type}AddressId`} value={this.state[`${type}AddressId`] || ''} onChange={event => this.setState({ [`${type}AddressId`]: event.target.value })}>
                                    <FormattedMessage id="selectOptions" defaultMessage="Select an option">{message => <option value="">{message}</option>}</FormattedMessage>
                                    {this.props.addresses.map(address => <option key={address._id} value={address._id}>{`${address.label || address.name}`}</option>)}
                                </Input>
                            )}
                            <ListGroup>
                                {this.props.addresses.map(address => (
                                    <ListGroupItem key={address._id} className="d-flex justify-content-between" onClick={event => this.setState({ [`${type}AddressId`]: address._id })}>
                                        <FormGroup check>
                                            <Input type="radio" name={`${type}AddressId`} value={address._id} checked={this.state[`${type}AddressId`] === address._id} onChange={event => this.setState({ [`${type}AddressId`]: event.target.value })} />
                                        </FormGroup>
                                        <AddressView address={address} inline />
                                        <a href="#" className="text-uppercase" onClick={event => { event.preventDefault(); this.setState({ [`${type}AddressId`]: address._id, [`display${capitalizeFirstLetter(type)}AddressForm`]: true }); }}><FormattedMessage id="edit" defaultMessage="Edit" /></a>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>


                            <a href="#" className="d-block p-3 text-right text-uppercase" onClick={event => { event.preventDefault(); this.setState({ [`display${capitalizeFirstLetter(type)}AddressForm`]: true, [`${type}AddressId`]: null }); }}><FormattedMessage id="add" defaultMessage="Add" /></a>
                        </FormGroup>

                        {
                            false && this.state[`${type}AddressId`] && (
                                <div className="text-center text-md-left">
                                    <AddressView address={this.props.addresses.find(address => address._id === this.state[`${type}AddressId`])} />
                                    <a href="#" className="text-uppercase" onClick={event => { event.preventDefault(); this.setState({ [`display${capitalizeFirstLetter(type)}AddressForm`]: true }); }}><FormattedMessage id="edit" defaultMessage="Edit" /></a>
                                </div>
                            )
                        }
                    </Col>
                </Row>
            );
        }
        return (
            <div className="">
                <span className="d-block my-3 h5 text-primary"><FormattedMessage id={`address${capitalizeFirstLetter(type)}`} defaultMessage={`${capitalizeFirstLetter(type)} address`} /></span>

                <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressName`) && 'has-danger')}>
                    <Input type="text" name="name" className={classnames(this.hasErrorField(`${type}AddressName`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressName', defaultMessage: 'Name' })} value={this.state[`${type}Address`].name} />
                </FormGroup>
                <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressStreet1`) && 'has-danger')}>
                    <Input type="text" name="street1" className={classnames(this.hasErrorField(`${type}AddressStreet1`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressStreet1', defaultMessage: 'Address' })} value={this.state[`${type}Address`].street1} />
                </FormGroup>
                <Row noGutters>
                    <Col xs="12" sm="6">
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressNameAlt`) && 'has-danger')}>
                            <Input type="text" name="nameAlt" className={classnames(this.hasErrorField(`${type}AddressNameAlt`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressNameAlt', defaultMessage: 'Company name (in case of office delivery)' })} value={this.state[`${type}Address`].nameAlt} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressStreet2`) && 'has-danger')}>
                            <Input type="text" name="street2" className={classnames(this.hasErrorField(`${type}AddressStreet2`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressStreet2', defaultMessage: 'Apartment, office, ...' })} value={this.state[`${type}Address`].street2} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row noGutters>
                    <Col xs="12" sm="6">
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressPostalCode`) && 'has-danger')}>
                            <Input type="text" name="postalCode" className={classnames(this.hasErrorField(`${type}AddressPostalCode`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressPostalCode', defaultMessage: 'Postal code' })} value={this.state[`${type}Address`].postalCode} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressCity`) && 'has-danger')}>
                            <Input type="text" name="city" className={classnames(this.hasErrorField(`${type}AddressCity`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressCity', defaultMessage: 'City' })} value={this.state[`${type}Address`].city} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row noGutters>
                    <Col>
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressRegion`) && 'has-danger')}>
                            <Input type="text" name="region" value={this.state[`${type}Address`].region} placeholder={this.props.intl.formatMessage({ id: 'addressRegion', defaultMessage: 'Region' })} className={classnames(this.hasErrorField(`${type}AddressRegion`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} />
                        </FormGroup>
                    </Col>
                    <Col xs="12" sm="6">
                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressCountry`) && 'has-danger')}>
                            <Autocomplete
                                getItemValue={item => getCountryNameTranslation(item, this.props.intl.locale)}
                                items={this.countries}
                                renderItem={(item, isHighlighted) => (
                                    <div key={item.cca2} className="p-2" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                        {getCountryNameTranslation(item, this.props.intl.locale)}
                                    </div>
                                )}
                                shouldItemRender={(item, value) => getCountryNameTranslation(item, this.props.intl.locale).toLowerCase().indexOf(value.toLowerCase()) > -1}
                                value={this.state[`${type}Address`].country}
                                onChange={event => this.handleChangeAddress(event, type)}
                                onSelect={val => this.handleChangeAddress({ target: { name: 'country', value: val } }, type)}
                                inputProps={{
                                    className: classnames('form-control', this.hasErrorField(`${type}AddressCity`) && 'is-invalid form-control-danger'),
                                    placeholder: this.props.intl.formatMessage({ id: `address${capitalizeFirstLetter(type)}Country`, defaultMessage: `${capitalizeFirstLetter(type)} country` }),
                                    name: 'country',
                                }}
                                wrapperStyle={{}}
                                menuStyle={{
                                    borderRadius: '3px',
                                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                                    padding: '2px 0',
                                    fontSize: '90%',
                                    position: 'fixed',
                                    overflow: 'auto',
                                    maxHeight: '50%',
                                    zIndex: 999,
                                    background: '#fff',
                                }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField(`${type}AddressPhone`) && 'has-danger')}>
                    <Input type="text" name="phone" className={classnames(this.hasErrorField(`${type}AddressPhone`) && 'is-invalid form-control-danger')} onChange={event => this.handleChangeAddress(event, type)} placeholder={this.props.intl.formatMessage({ id: 'addressPhone', defaultMessage: 'Phone (useful for delivery)' })} value={this.state[`${type}Address`].phone} />
                </FormGroup>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    {
                        !this.props.user && (
                            <Fragment>
                                <span className="d-block my-3 h5 text-primary"><FormattedMessage id="userAccoutDetailsTitle" defaultMessage="Your account details" /></span>
                                <Row noGutters>
                                    <Col xs="12" sm="6">
                                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField('firstName') && 'has-danger')}>
                                            <Input type="text" name="firstName" id="firstNameField" className={classnames(this.hasErrorField('firstName') && 'is-invalid form-control-danger')} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userFirstName', defaultMessage: 'First name' })} value={this.state.firstName} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField('lastName') && 'has-danger')}>
                                            <Input type="text" name="lastName" id="lastNameField" className={classnames(this.hasErrorField('lastName') && 'is-invalid form-control-danger')} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userLastName', defaultMessage: 'Last name' })} value={this.state.lastName} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row noGutters>
                                    <Col xs="12" sm="6">
                                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField('email') && 'has-danger')}>
                                            <Input type="email" name="email" id="emailField" className={classnames(this.hasErrorField('email') && 'is-invalid form-control-danger')} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userEmail', defaultMessage: 'Email' })} value={this.state.email} />
                                            {
                                                this.hasErrorField('email')
                                                ? <FormFeedback><FormattedMessage id="userEmailError" defaultMessage="Your email address is incorrect!" /></FormFeedback>
                                                : null
                                            }
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup className={classnames('mr-2', 'mb-2', this.hasErrorField('password') && 'has-danger')}>
                                            <Input type="password" name="password" id="passwordField" className={classnames(this.hasErrorField('password') && 'is-invalid form-control-danger')} onChange={this.handleChange} placeholder={this.props.intl.formatMessage({ id: 'userPassword', defaultMessage: 'Password' })} value={this.state.password} />
                                            {
                                                this.hasErrorField('password')
                                                ? <FormFeedback><FormattedMessage id="userPasswordRestrictionAlt" defaultMessage="The password must have 6 characters!" /></FormFeedback>
                                                : null
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Fragment>
                        )
                    }

                    {this.renderAddressForm('shipping')}

                    <FormGroup>
                        <Label className="d-block my-3 h5 text-primary"><FormattedMessage id="addressInvoiceSameAsShippingLabel" defaultMessage="Is the billing data identical to the delivery data?" /></Label>
                        <FormGroup check inline>
                            <Label check>
                                <Input type="radio" name="hasDistinctInvoiceAddress" checked={!this.state.hasDistinctInvoiceAddress} onChange={event => this.setState({ hasDistinctInvoiceAddress: !event.target.checked })} /> <FormattedMessage id="yes" defaultMessage="Yes" />
                            </Label>
                        </FormGroup>
                        <FormGroup check inline>
                            <Label check>
                                <Input type="radio" name="hasDistinctInvoiceAddress" checked={this.state.hasDistinctInvoiceAddress} onChange={event => this.setState({ hasDistinctInvoiceAddress: event.target.checked })} /> <FormattedMessage id="no" defaultMessage="No" />
                            </Label>
                        </FormGroup>
                    </FormGroup>

                    {this.state.hasDistinctInvoiceAddress && this.renderAddressForm('invoice')}

                    <FormGroup check inline className="my-3">
                        <Label check>
                            <Input type="checkbox" name="isSubscribingNewsletter" checked={this.state.isSubscribingNewsletter} onChange={this.handleChange} /> <CmsPanel slug="newsletter-subscribe-check" />
                        </Label>
                    </FormGroup>

                    <FormGroup className="mt-3">
                        <ButtonGroup className="btn-block">
                            <Button color="warning" size="lg" disabled={this.state.isProcessing}>
                                {this.state.isProcessing && <FontAwesome name="spinner" spin />} <FormattedMessage id="cartShippingValidateDetails" defaultMessage="Validate delivery details" />
                            </Button>
                        </ButtonGroup>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    const user = getLoggedUser(store);
    return {
        user,
        addresses: user ? getAddresses(store, user._id) : [],
    };
}

UserRegisterAndAddressForm.defaultProps = {
    user: null,
    addresses: [],
};

UserRegisterAndAddressForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    user: PropTypes.object,
    addresses: PropTypes.arrayOf(PropTypes.object),
    closeForm: PropTypes.func,
};

export default connect(mapStateToProps)(injectIntl(withRouter(UserRegisterAndAddressForm)));
